import { c as _c } from "react/compiler-runtime";
import BookButton from '@/components/modules/entityBookButtons/BookButton';
import OfferButton from '@/components/modules/entityBookButtons/OfferButton';
const EntityButtons = t0 => {
    const $ = _c(8);
    const { entityId, canBeGifted } = t0;
    let t1;
    if ($[0] !== entityId) {
        t1 = <BookButton entityId={entityId} className="w-35 flex-shrink mb-2 ml-2 last:ml-0 "/>;
        $[0] = entityId;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    let t2;
    if ($[2] !== canBeGifted || $[3] !== entityId) {
        t2 = canBeGifted ? <OfferButton entityId={entityId} className="w-35 flex-shrink mb-2 ml-2 last:ml-0 "/> : null;
        $[2] = canBeGifted;
        $[3] = entityId;
        $[4] = t2;
    }
    else {
        t2 = $[4];
    }
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = <div className="book-buttons w-full flex flex-row-reverse justify-center items-center mt-2 md:justify-start ">{t1}{t2}</div>;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    }
    else {
        t3 = $[7];
    }
    return t3;
};
export default EntityButtons;
